module.exports = "<app-header> </app-header>\r\n\r\n<router-outlet class=\"top\"></router-outlet>\r\n\r\n<app-footer></app-footer>\r\n"